module.exports = __webpack_public_path__ + "img/forgetting-curve.436f17db.svg";